export default __webpack_public_path__ + "static/media/17.559ce951.mp3";